define('collections/calendar/favorites',[
    'underscore', 'backbone', 'utils',
    // src
    'services/api',
    // super class
    'src/plugins/infinite-collection',
    // models
    'models/calendar/favorite',
], function(
    _, Backbone, U, API,
    // super class
    InfiniteCollection,
    // models
    MFavorite
) {

    var CFavorites = InfiniteCollection.extend({
        // comparator: "name",
        model: MFavorite,
        state: {
            pageSize: 75,
        },
        url: function() {
            return API.url('favorites/' + this.type);
        },
        initialize: function(models, options) {
            options = options || {};
            this.type = options.type;
        },

        /**
         * FIXME filters (search) is unused as it's not included in the
         * current feature requirements.
         */
        // setFilter: function(query) {
        //     this.query = query;
        //     return this;
        // },
        //
        // resetFilter: function() {
        //     this.setFilter();
        //     return this;
        // }
    });

    return CFavorites;
});

